import { useState } from "react";
import { IoClose } from "react-icons/io5";

const BrandStyle = ({ overallStylePreference, setOverallStylePreference, fontStylePreference, setFontStylePreference, onNext, onBack, logos, setLogos, brandColors, setBrandColors }) => {

    function getImageSrc(item) {
        if (!item) return null;

        // New upload
        if (item instanceof File) {
            return URL.createObjectURL(item);
        }

        // Existing image URL
        if (typeof item === "string") {
            return item;
        }

        return null;
    }


    return (
        <div style={styles.wrapper}>
            <h2 style={styles.title}>Define your brand style</h2>

            {/* Brand Colors */}
            <div style={styles.section}>
                <p style={styles.label}>Your Brand Colors (up to 3)</p>

                <div style={styles.colorRow}>
                    {brandColors.map((color, index) => (
                        <div key={index} style={styles.colorInputWrapper}>

                            {/* Color Box */}
                            <input
                                type="color"
                                value={color}
                                style={styles.colorBox}
                                onChange={(e) => {
                                    const updated = [...brandColors];
                                    updated[index] = e.target.value;
                                    setBrandColors(updated);
                                }}
                            />

                            {/* Hex Input */}
                            <input
                                type="text"
                                value={color}
                                placeholder="#000000"
                                style={styles.colorText}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^#([0-9A-Fa-f]{0,6})$/.test(value)) {
                                        const updated = [...brandColors];
                                        updated[index] = value;
                                        setBrandColors(updated);
                                    }
                                }}
                            />
                        </div>
                    ))}
                </div>
            </div>

            {/* Font Style */}
            <div style={styles.section}>
                <p style={styles.label}>Font Style Preference</p>
                <div style={styles.optionRow}>
                    <button style={fontStylePreference === 'Modern' ? styles.activeOption : styles.option} onClick={() => setFontStylePreference('Modern')}>Modern</button>
                    <button style={fontStylePreference === 'Classic' ? styles.activeOption : styles.option} onClick={() => setFontStylePreference('Classic')}>Classic</button>
                    <button style={fontStylePreference === 'Playful' ? styles.activeOption : styles.option} onClick={() => setFontStylePreference('Playful')}>Playful</button>
                </div>
            </div>

            {/* Overall Style */}
            <div style={styles.section}>
                <p style={styles.label}>Overall Style Preference</p>
                <div style={styles.optionRow}>
                    <button style={overallStylePreference === 'Professional' ? styles.activeOption : styles.option} onClick={() => setOverallStylePreference('Professional')}>Professional</button>
                    <button style={overallStylePreference === 'Creative' ? styles.activeOption : styles.option} onClick={() => setOverallStylePreference('Creative')}>Creative</button>
                    <button style={overallStylePreference === 'Minimal' ? styles.activeOption : styles.option} onClick={() => setOverallStylePreference('Minimal')}>Minimal</button>
                    <button style={overallStylePreference === 'Bold' ? styles.activeOption : styles.option} onClick={() => setOverallStylePreference('Bold')}>Bold</button>
                </div>
            </div>

            {/* Logo Upload */}

            <div style={styles.section}>
                <p style={styles.label}>Upload Your Logos (PNG, JPEG, or SVG)</p>
                <p style={styles.subText}>
                    Upload logo (light/dark, with or without text)
                </p>

                <div style={styles.uploadRow}>
                    {logos.map((logo, index) => (
                        <div key={index} style={styles.uploadCard}>
                            {logo ? (
                                <>
                                    <img
                                        src={getImageSrc(logo)}
                                        alt="Logo preview"
                                        style={styles.logoPreview}
                                    />
                                    <button
                                        style={styles.removeBtn}
                                        onClick={() => {
                                            const updated = [...logos];
                                            updated[index] = null;
                                            setLogos(updated);
                                        }}
                                    >
                                        <IoClose size={18} color='white' />
                                    </button>
                                </>
                            ) : (
                                <>
                                    <label style={styles.uploadLabel}>
                                        <input
                                            type="file"
                                            accept="image/png, image/jpeg, image/svg+xml"
                                            style={{ display: "none" }}
                                            onChange={(e) => {
                                                if (!e.target.files[0]) return;
                                                const updated = [...logos];
                                                updated[index] = e.target.files[0];
                                                setLogos(updated);
                                            }}
                                        />
                                        <div style={styles.uploadIcon}>＋</div>
                                        <p style={styles.uploadText}>Add Logo</p>
                                    </label>
                                </>
                            )}
                        </div>
                    ))}
                </div>
            </div>


            {/* Footer Buttons */}
            <div style={styles.footer}>
                <button onClick={onBack} style={styles.backBtn}>Back</button>
                <button onClick={onNext} style={styles.primaryBtn}>
                    ✨ Continue to Examples
                </button>
            </div>
        </div>
    );
};


export default BrandStyle;

const styles = {
    wrapper: {
        width: "100%",
        backgroundColor: "#000",
        padding: 32,
        color: 'white'
    },

    title: {
        fontSize: 28,
        fontWeight: 700,
        marginBottom: 28,
        textAlign: 'left'
    },

    section: {
        marginBottom: 28,
    },

    label: {
        fontSize: 16,
        fontWeight: 600,
        marginBottom: 10,
        textAlign: "left",
    },

    subText: {
        fontSize: 14,
        color: "#9CA3AF",
        marginBottom: 16,
        textAlign: "left"
    },

    colorRow: {
        display: "grid",
        gridTemplateColumns: "repeat(3, minmax(0, 1fr))", // ✅ 3 columns, never overflow
        gap: 12,
        width: "100%",
        boxSizing: "border-box",
    },
    colorInputWrapper: {
        display: "flex",
        alignItems: "center",
        gap: 10,
        minWidth: 0, // ✅ important for grid children
    },
    colorText: {
        width: "100%",         // ✅ fill remaining space inside the cell
        minWidth: 0,           // ✅ prevents overflow
        height: 44,
        borderRadius: 8,
        border: "none",
        padding: "0 12px",
        fontSize: 14,
        boxSizing: "border-box",
    },

    colorBox: {
        width: 44,
        height: 44,
        borderRadius: 8,
        border: "2px solid #FFFFFF",
        background: "transparent",
        cursor: "pointer",
    },

    optionRow: {
        display: "flex",
        gap: 16,
        flexWrap: "wrap",
    },

    option: {
        background: "#1F2937",
        color: "#FFFFFF",
        padding: "12px 24px",
        borderRadius: 12,
        border: "1px solid #374151",
        cursor: "pointer",
        fontWeight: 500,
    },

    activeOption: {
        background: "#3A2A12",
        color: "#F6A21A",
        padding: "12px 24px",
        borderRadius: 12,
        border: "1px solid #F6A21A",
        fontWeight: 600,
    },

    uploadRow: {
        display: "flex",
        gap: 20,
        marginTop: 12,
    },

    uploadBox: {
        width: 150,
        height: 170,
        background: "#1F2937",
        borderRadius: 12,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#9CA3AF",
    },

    addBox: {
        width: 150,
        height: 170,
        background: "#FFFFFF",
        color: "#000000",
        borderRadius: 12,
        border: "2px dashed #F6A21A",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: 600,
        cursor: "pointer",
    },

    footer: {
        display: "flex",
        justifyContent: "space-between",
        marginTop: 36,
    },

    backBtn: {
        background: "#1F2937",
        color: "#FFFFFF",
        padding: "14px 36px",
        borderRadius: 14,
        border: "none",
        fontSize: 16,
        cursor: "pointer",
    },

    primaryBtn: {
        background: "#F6A21A",
        color: "#000000",
        padding: "14px 36px",
        borderRadius: 14,
        border: "none",
        fontSize: 16,
        fontWeight: 700,
        cursor: "pointer",
    },
    backBtn: {
        background: "#1F2937",
        color: "#FFFFFF",
        padding: "18px 48px",     // 🔥 bigger
        borderRadius: 18,        // 🔥 more rounded
        border: "none",
        fontSize: 18,            // 🔥 larger text
        fontWeight: 600,
        cursor: "pointer",
    },

    primaryBtn: {
        background: "#F6A21A",
        color: "#000000",
        padding: "18px 48px",     // 🔥 bigger
        borderRadius: 18,        // 🔥 more rounded
        border: "none",
        fontSize: 18,            // 🔥 larger text
        fontWeight: 700,
        cursor: "pointer",
    },

    backBtn: {
        flex: 1,                 // 🔥 smaller portion
        background: "#1F2937",
        color: "#FFFFFF",
        height: 56,              // 🔥 fixed height (image-like)
        borderRadius: 16,
        border: "none",
        fontSize: 16,
        fontWeight: 600,
        cursor: "pointer",
    },
    primaryBtn: {
        flex: 2.5,               // 🔥 bigger portion
        background: "#F6A21A",
        color: "#000000",
        height: 56,              // same height
        borderRadius: 16,
        border: "none",
        fontSize: 18,
        fontWeight: 700,
        cursor: "pointer",
    },
    footer: {
        display: "flex",
        gap: 20,
        marginTop: 36,
        width: "100%",
    },

    uploadRow: {
        display: "flex",
        gap: 20,
        marginTop: 16,
    },

    uploadCard: {
        width: 160,
        height: 180,
        background: "#1F2937",
        borderRadius: 14,
        position: "relative",
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },

    uploadLabel: {
        width: "100%",
        height: "100%",
        cursor: "pointer",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        color: "#9CA3AF",
    },

    uploadIcon: {
        fontSize: 32,
        color: "#F6A21A",
        marginBottom: 6,
    },

    uploadText: {
        fontSize: 14,
    },

    logoPreview: {
        width: "100%",
        height: "100%",
        objectFit: "contain",
        padding: 16,
        background: "#FFFFFF",
    },

    removeBtn: {
        position: "absolute",
        top: 5,
        right: 5,
        // transform: "translateX(-50%)",
        background: "#FF0707",
        color: "#FFFFFF",
        border: "none",
        borderRadius: '50%',
        padding: "2px 4px",
        fontSize: 12,
        cursor: "pointer",
    },


};

